export default "__VITE_ASSET__DtvDkLbe__"